import Achievements from './Achievements';
import './App.css';
import Footer from './Footer';
import Home from './Home';
import HomeContact from './HomeContact';
import Navbar from './Navbar';
import Slider from './Slider';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import About from './about-us/About';
import Contact from './contact/Contact';
import Service from './services/Service';
import Affliliates from './Affiliates';



function App() {


  const redirectToTop = () => {
    window.scrollTo(0,0);
  }


  return (
    <Router> 
      <div className="app">
      <Navbar redirectToTop = {redirectToTop}/>

      <Switch>
        <Route exact path="/">
          <Slider redirectToTop = {redirectToTop}/>
          <Achievements />
          <Home redirectToTop = {redirectToTop}/>
          <Affliliates />
          <HomeContact />
          
        </Route>
        
        <Route path="/about">
          <About />
        </Route>

        <Route path="/service">
          <Service />
        </Route>
        
        <Route path="/contact">
          <Contact />
        </Route>
      </Switch>
      <Footer redirectToTop = {redirectToTop}/>
      </div>
    </Router>
  );
}

export default App;
